import React, { useRef } from 'react';
import { QRCodeCanvas } from "qrcode.react";
import { PublicFormsMetaProps } from "../data/types"
import { Modal } from './ui/Modal'
import { Button } from './ui/Button'
import { DownloadIcon } from '../icons'

type Props = {
    meta: PublicFormsMetaProps;
    isOpen: boolean;
    onClose: () => void;
    url: string;
    slug: string;
    copied: boolean;
    onCopyLink: () => void;
}

export const QRCodeModal = (props: Props) => {
    const { meta, isOpen, onClose, url, slug, copied, onCopyLink } = props;

    const canvasRef = useRef<HTMLCanvasElement>(null);

    const handleDownload = () => {
        const canvas = canvasRef.current
        if (!canvas) return

        const link = document.createElement('a')
        link.href = canvas.toDataURL('image/png')
        link.download = `${slug}-qr-code.png`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    const footer = (
        <div className="flex justify-end">
            <Button type="button" onClick={onClose} variant="outline" color="neutral">
                {meta.qrCodeCloseButton}
            </Button>
        </div>
    );
    
    return (
        <Modal isOpen={isOpen} onClose={onClose} title={meta.qrCodeModalTitle} maxWidth="sm" footer={footer}>
            <div className="px-6 py-4 space-y-4">
                <p className="text-sm text-gray-600 dark:text-gray-400">{meta.qrCodeModalDescription}</p>

                <div className="flex justify-center">
                    <div className="bg-white p-4 rounded-md border border-gray-200">
                        <QRCodeCanvas ref={canvasRef} value={url} size={220} level="M" marginSize={2} />
                    </div>
                </div>

                <p className="text-xs text-gray-500 dark:text-gray-400 break-all text-center">{url}</p>

                <div className="flex flex-wrap justify-center gap-2 pt-2">
                    <Button variant="outline" color="neutral" onClick={onCopyLink}>
                        {copied ? meta.copiedText : meta.copyLinkButton}
                    </Button>
                    <Button variant="outline" color="primary" onClick={handleDownload}>
                        <DownloadIcon className="w-4 h-4" />
                        {meta.downloadPngButton}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
